import { render, staticRenderFns } from "./Learning.vue?vue&type=template&id=06477052&scoped=true"
import script from "./Learning.vue?vue&type=script&lang=ts"
export * from "./Learning.vue?vue&type=script&lang=ts"
import style0 from "./Learning.vue?vue&type=style&index=0&id=06477052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06477052",
  null
  
)

export default component.exports